import game from "@/api/game";

const state = {
    games: []
};

const getters = {
    games: state => {
        return state.games;
    }
};

const actions = {
    get({ commit }) {
        return game
            .get()
            .then(response => {
                if (response.status === 200) {
                    commit("SET_GAMES", response.data.data);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    }
};

const mutations = {
    SET_GAMES(state, value) {
        state.games = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
